import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl, getSeoForPath, defaultImage, siteUrl } from '../data/seo';

const setMetaTag = (attribute, name, content) => {
    let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};

const setLinkTag = (rel, href) => {
    let element = document.head.querySelector(`link[rel="${rel}"]`);
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
};

export const SEO = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const metadata = getSeoForPath(pathname);
        const canonicalUrl = getCanonicalUrl(pathname);

        document.title = metadata.title;
        setMetaTag('name', 'description', metadata.description);
        setMetaTag('name', 'robots', metadata.noIndex ? 'noindex,nofollow' : 'index,follow');
        setMetaTag('property', 'og:site_name', 'Tressym Drone Labs');
        setMetaTag('property', 'og:title', metadata.title);
        setMetaTag('property', 'og:description', metadata.description);
        setMetaTag('property', 'og:image', metadata.image || defaultImage);
        setMetaTag('property', 'og:image:alt', 'Tressym Drone Labs open-source FPV designs');
        setMetaTag('property', 'og:url', canonicalUrl);
        setMetaTag('property', 'og:type', metadata.type === 'Product' ? 'product' : metadata.type === 'Article' ? 'article' : 'website');
        setMetaTag('name', 'twitter:title', metadata.title);
        setMetaTag('name', 'twitter:description', metadata.description);
        setMetaTag('name', 'twitter:image', metadata.image || defaultImage);
        setMetaTag('name', 'twitter:url', canonicalUrl);
        setLinkTag('canonical', canonicalUrl);

        const structuredData = {
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@type': 'Organization',
                    '@id': `${siteUrl}/#organization`,
                    name: 'Tressym Drone Labs',
                    url: siteUrl,
                    logo: defaultImage,
                    sameAs: ['https://discord.gg/rRCda9KUWR', 'https://tressym.myshopify.com']
                },
                {
                    '@type': 'WebSite',
                    '@id': `${siteUrl}/#website`,
                    name: 'Tressym Drone Labs',
                    url: siteUrl,
                    publisher: { '@id': `${siteUrl}/#organization` }
                },
                {
                    '@type': metadata.type,
                    '@id': `${canonicalUrl}#page`,
                    url: canonicalUrl,
                    name: metadata.title,
                    description: metadata.description,
                    isPartOf: { '@id': `${siteUrl}/#website` },
                    ...(metadata.productName ? {
                        brand: { '@type': 'Brand', name: 'Tressym Drone Labs' },
                        image: defaultImage
                    } : {})
                }
            ]
        };

        let script = document.head.querySelector('script[data-tressym-schema]');
        if (!script) {
            script = document.createElement('script');
            script.type = 'application/ld+json';
            script.dataset.tressymSchema = 'true';
            document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(structuredData);
    }, [pathname]);

    return null;
};